export const ROUTES = {
    contact: '/contact-us',
    leadership: '/leadership',
    careers: '/careers',
    devops_jd: '/careers/devops-engineer-requirment',
    android_jd: '/careers/android-developer-requirement',
    ios_jd: '/careers/ios-developer-requirement',
    java_jd: '/careers/java-developer-requirement',
    marcom_jd:'/careers/product-marketing-associate',
    customer_support_jd: '/careers/inside-sales-and-customer-support-specialist',
    jr_qa_jd: '/careers/junior-QA-engineer',
    sr_software_engineer_ios: '/careers/senior-software-engineer-ios',
    sr_software_engineer_android: '/careers/senior-software-engineer-android',
    projectmanager_jd:'/careers/project-manager-requirement',
    mobilelead_jd:'/careers/mobile-app-lead-manager',
    productmanager_jd:'/careers/product-manager',
    // Products (legacy)
    cariq_cloud: '/products/automotive-cloud',
    cariq_insurance_cloud: '/Varroc-Connect-Insurance-Cloud',
    cariq_tls_cloud: '/Varroc-Connect-TLS-Cloud',
    cariq_apps: '/products/automotive-applications',
    cariq_score: '/products/automotive-score',
    cariq_varroc_connect_hardware: '/products/automotive-hardware',
    // Products (new)
    products: '/products',
    products_hardware: '/products/hardware',
    products_connectiq: '/products/connectiq',
    products_connectiq_babelfish: '/products/connectiq/babelfish',
    products_connectiq_w4iq: '/products/connectiq/w4iq',
    products_connectiq_vc_score: '/products/connectiq/vc-score',
    products_connectiq_miles: '/products/connectiq/miles',
    products_connectiq_vstore: '/products/connectiq/vstore',
    products_connectiq_cap: '/products/connectiq/cap',
    products_unitedsdk: '/products/unifiedsdk',
    products_unifiedsdk_mobile: '/products/unifiedsdk/mobile',
    products_unitedsdk_web: '/products/unifiedsdk/web',
    products_unitedsdk_iot: '/products/unifiedsdk/iot',
    // Hardware sub-pages
    products_hardware_obd: '/products/hardware/obd',
    products_hardware_tcu: '/products/hardware/tcu',
    products_hardware_dashcam: '/products/hardware/dashcam',
    products_hardware_cluster: '/products/hardware/cluster',
    // ConnectIQ new microsites
    products_connectiq_oasis: '/products/connectiq/oasis',
    products_connectiq_iiot: '/products/connectiq/iiot',
    products_connectiq_vehicle_app_store: '/products/connectiq/vehicle-app-store',
    products_connectiq_secureiq: '/products/connectiq/secureiq',
    products_connectiq_context_based_messaging: '/products/connectiq/iq360',
    // Platform
    platform: '/platform',
    // Solutions (legacy)
    cariq_automotive_solution: '/solutions/automotive-smart-solutions',
    cariq_tls_solution: '/solutions/automotive-tls-solutions',
    cariq_bfsi: '/solutions/automotive-banking-finance-insurance-services',
    cariq_vehicleusers: '/solutions/automotive-vehicle-users-b2c-solutions',
    // Solutions (new)
    solutions: '/solutions',
    solutions_business: '/solutions/business',
    solutions_business_oem: '/solutions/business/automotive-oem',
    solutions_business_fleet: '/solutions/business/fleet-logistics',
    solutions_business_insurance: '/solutions/business/insurance',
    solutions_business_enterprise: '/solutions/business/enterprise',
    solutions_consumers: '/solutions/consumers',
    solutions_consumers_connected_car: '/solutions/consumers/connected-car',
    solutions_consumers_safety: '/solutions/consumers/safety-alerts',
    solutions_consumers_rewards: '/solutions/consumers/rewards',
    solutions_consumers_device_store: '/solutions/consumers/device-store',
    // Resources
    resources: '/resources',
    media: '/media',
    // Policy & About
    about_us: '/about-us',
    privacy_policy: '/privacy-policy',
    refund_and_return: '/refund-and-return-policy',
    shipping_and_cancellation_policy: '/shipping-and-cancellation-policy',
    terms_and_conditions: '/terms-and-conditions',
    cyber_security: '/cyber-security'
};